import type { ReceivedResellerAuthorization } from '../../../modules/receivedResellerAuthorization/types'
import { allAuthorizationsOption } from './constants'

export const getActiveReceivedResaleAuthList = (
  authorizations: ReceivedResellerAuthorization[]
) => [
  allAuthorizationsOption,
  ...authorizations.map(activeReceivedResellerAuthorizationItem => ({
    label: activeReceivedResellerAuthorizationItem.agreementName,
    value: activeReceivedResellerAuthorizationItem.id,
    key: activeReceivedResellerAuthorizationItem.id,
  })),
]
